export default {
  label: {
    title: {
      noCardsSelected: 'Nenhum componente adicionado ao dashboard',
    },
    button: {
      addChartButton: 'Adicionar componente',
    },
  },
};
